import { ScientificAnalysisFieldDTO } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { ScientificAnalysisCondition } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'

export interface ScientificAnalysisFilterConditionGroup {
    fieldGroup: ScientificAnalysisFieldDTO,
    conditions: ScientificAnalysisCondition[]
}

export interface ScientificAnalysisFilterPanelState {
    filterFieldText: string
    entityFields: ScientificAnalysisFieldDTO[]
}
export const initialScientificAnalysisFilterPanelState =
    (): ScientificAnalysisFilterPanelState => ({
        filterFieldText: '',
        entityFields: []
    })
